export class DeptoI{
  id: BigInteger;
  codigo: String;
  nombre: String;
}
